class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection-grid-container').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle?.hasAttribute('open') && !this.mainDetailsToggle?.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

window.addEventListener("DOMContentLoaded", function () {
  ee007Test();
  initFilters();

});

function initFilters() {

  const $doc = document;
  const $body = $doc.body;
  const filterWrapper = $body.querySelector('.facets-wrapper');
  const filters = $body.querySelector('.facets__disclosure');
  let filtersOpen = false;
  const isMobile = window.innerWidth < 768;
  if (!filters) return;
  // isMobile ? '' : filterWrapper.classList.add('container');
  let filterWrapperOptions = $body.querySelectorAll('.facets__disclosure');
  let currElem;
  if (isMobile) {
    let mobileFilter = $body.querySelector('.mobile-facets__wrapper');
    let mobileFilterWrapper = $body.querySelector('#FacetsWrapperMobile');
    mobileFilterWrapper.firstElementChild.insertAdjacentHTML('beforebegin', `<div class="active-filters-wrapper"><h1>Applied Filters</h1></div>`);
    let activeFilters = $body.querySelector('.active-facets-mobile');
    let newActiveFilterWrapper = $body.querySelector('.active-filters-wrapper');
    if (activeFilters.querySelector('.active-facets__button')) {
      activeFilters.querySelector('.active-facets__button-remove span').innerText = 'Clear';
      newActiveFilterWrapper.append(activeFilters.cloneNode(true));
      newActiveFilterWrapper.classList.add('active');
    }
    else {
      newActiveFilterWrapper.classList.remove('active');
    }
    const mobileFooter = mobileFilterWrapper.lastElementChild;
    mobileFooter.innerHTML = '<a class="ee007v2-close-btn ee007v2-apply" href="javascript:void(0)">apply</a>';
    filterWrapperOptions = $body.querySelectorAll('.mobile-facets__details');
    // const header = $body.querySelector('.mobile-facets__heading');
    // header.insertAdjacentHTML('afterend', `<a href="javascript:void(0)" class="ee007v2-close-btn"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    // <path d="M18 6L6 18" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    // <path d="M6 6L18 18" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    // </svg>
    // </button>`);
    // filterWrapper.lastElementChild.insertAdjacentHTML('beforebegin', `<div class="mobile-filter-btn">Filter</div>`);
    $doc.addEventListener('click', function (event) {
      if (event.target.classList.contains('ee007v2-close-btn') || event.target.closest('.ee007v2-close-btn')) {

        $body.querySelector('.mobile-facets__wrapper').classList.remove('active');
        filtersOpen = false;
        $body.classList.remove('mobile-filter-active');
      }
      else if (event.target.classList.contains('mobile-filter-btn') || event.target.closest('.mobile-filter-btn')) {
        $body.querySelector('.mobile-facets__wrapper').classList.add('active');
        filtersOpen = true;
        $body.classList.add('mobile-filter-active');
      }
    })
  }
  $doc.addEventListener('click', function (event) {
    if (event.target.classList.contains('facets__disclosure') || event.target.closest('.facets__disclosure'));
    const activeFilterDropdown = $body.querySelector('.facets__disclosure.active');
    // activeFilterDropdown ? activeFilterDropdown.click() : '';
  });


  for (const option of filterWrapperOptions) {
    option.addEventListener('click', function () {
      if (this !== currElem) {
        const activeElem = isMobile ? $body.querySelector('.mobile-facets__details.active') : $body.querySelector('.facets__disclosure.active');
        activeElem ? activeElem.classList.remove('active') : '';
      }
      if (this.classList.contains('active')) {
        this.classList.remove('active');
      }
      else {
        this.classList.add('active');
      }
      currElem = this;
    });
  }


  if (isMobile) {
    filterWrapperOptions[0].click();
  }
  if ($body.querySelector('.ee007v2-container')) return;
  const upsellWrapper = $body.querySelector('.collection__upsell');
  const mainWrapper = $body.querySelector('#ProductGridContainer');
  const description = $body.querySelector('.collection__description-container');
  if (description) {
    mainWrapper.insertAdjacentElement('afterend', description.parentNode);
    description.parentNode.classList.add('ee007v2-container');
  }
  if (upsellWrapper) {
    mainWrapper.insertAdjacentElement('afterend', upsellWrapper);
    upsellWrapper.classList.add('ee007v2-container');
    isMobile ? '' : upsellWrapper.classList.add('container');
  }

  const targetNode = document.getElementById('ProductGridContainer');
  const config = { childList: true };

  // Callback function to execute when mutations are observed
  const callback = function (mutationsList, observer) {
    for (let mutation of mutationsList) {
      if (mutation.type === 'childList') {
        ee007Test();
        filterWrapperOptions = $body.querySelectorAll('.facets__disclosure');
        if (isMobile) {
          activeFilters = $body.querySelector('.active-facets-mobile');
          newActiveFilterWrapper = $body.querySelector('.active-filters-wrapper');
          if (activeFilters.querySelector('.active-facets__button')) {
            activeFilters.querySelector('.active-facets__button-remove span').innerText = 'Clear';
            newActiveFilterWrapper.append(activeFilters.cloneNode(true));
            newActiveFilterWrapper.classList.add('active');
          }
          else {
            newActiveFilterWrapper.classList.remove('active');
          }
          mobileFilter = $body.querySelector('.mobile-facets__wrapper');
          mobileFilterWrapper = $body.querySelector('#FacetsWrapperMobile');
          const mobileFooter = mobileFilterWrapper.lastElementChild;
          mobileFooter.innerHTML = '<a class="ee007v2-close-btn ee007v2-apply" href="javascript:void(0)">apply</a>';
          filterWrapperOptions = $body.querySelectorAll('.mobile-facets__details');
          // filterWrapper.lastElementChild.insertAdjacentHTML('beforebegin', `<div class="mobile-filter-btn">Filter</div>`);

          if (filtersOpen === true) {
            $body.querySelector('.mobile-facets__wrapper').classList.add('active');
          }
        }
        for (const option of filterWrapperOptions) {
          option.addEventListener('click', function () {
            if (this !== currElem) {
              const activeElem = isMobile ? $body.querySelector('.mobile-facets__details.active') : $body.querySelector('.facets__disclosure.active');
              activeElem ? activeElem.classList.remove('active') : '';
            }
            if (this.classList.contains('active')) {
              this.classList.remove('active');
            }
            else {
              this.classList.add('active');
            }
            currElem = this;
          });
        }
      }
    }
  }

  const observer = new MutationObserver(callback);
  observer.observe(targetNode, config);

  // $doc.querySelectorAll('.mobile-facets__submenu').forEach(function(element) {
  //   element.addEventListener('click', function(e) {
  //     e.stopImmediatePropagation();
  //   });
  // });
}

function initFilterEventListeners(currElem, filterWrapperOptions) {

}

function ee007Test() {
  // document.body.classList.add("EE007");
  const currentUrl = window.location.pathname;
  const itemsWrapper = document.querySelector(".collection__product-container");
  const mobile = window.innerWidth < 750;

  if (currentUrl.includes("/kids-skin-and-hair-care") && itemsWrapper) {
    document.querySelector(".filter__wrapper.kids").classList.add('show');

    let kidsLinks = document.querySelectorAll(".filter__wrapper.kids .filter__link");
    kidsLinks.forEach((link) => {
      link.addEventListener("click", (e) => {
        let url = e.target.dataset.url;
        handleFilterClick(url, e);
      });
    });
  }

  if (currentUrl.includes("/mom") && itemsWrapper) {
    document.querySelector(".filter__wrapper.mom").classList.add('show');

    let momLinks = document.querySelectorAll(".filter__wrapper.mom .filter__link");
    momLinks.forEach((link) => {
      link.addEventListener("click", (e) => {
        let url = e.target.dataset.url;
        handleFilterClick(url, e);
      });
    });
  }

  if (currentUrl.includes("/baby") && itemsWrapper) {
    document.querySelector(".filter__wrapper.baby").classList.add('show');

    let babyLinks = document.querySelectorAll(".filter__wrapper.baby .filter__link");
    babyLinks.forEach((link) => {
      link.addEventListener("click", (e) => {
        let url = e.target.dataset.url;
        handleFilterClick(url, e);
      });
    });
  }

  if (currentUrl.includes("/bundles")) {
    document.querySelector(".filter__wrapper.value-sets").classList.add('show');

    let bundleLinks = document.querySelectorAll(".filter__wrapper.value-sets .filter__link");
    bundleLinks.forEach((link) => {
      link.addEventListener("click", (e) => {
        let url = e.target.dataset.url;
        handleFilterClick(url, e);
      });
    });
  }

    if (mobile) {
     
    }

    function handleFilterClick(filterUrl, e) {
      if (document.querySelector(".filter__link.active")) {
        let activeElement = document.querySelector(".filter__link.active");
        activeElement.classList.remove("active");
        activeElement.setAttribute('aria-current', 'false');
      }
      if (e.target) {
        e.target.classList.add("active");
        e.target.setAttribute('aria-current', 'true');
      }

      filterOption(filterUrl);
    }

    function filterOption(filterUrl) {
      const url = filterUrl;


      fetch(url)
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.text();
        })
        .then((htmlContent) => {
          const parser = new DOMParser();
          const parsedHtml = parser.parseFromString(htmlContent, "text/html");
          const productContainers = parsedHtml.querySelector(
            ".collection__product-container"
          );
          const collectionTitle = parsedHtml.querySelector('.collection__heading').innerHTML;
          document.querySelector(".collection__product-container").innerHTML =
            productContainers.innerHTML;
          document.querySelector('.collection__heading').innerHTML = collectionTitle;
        })
        .catch((error) => {
          console.error("There was a problem with the fetch operation:", error);
        });
    }
  // }, 1000);
}